import { render } from "./modify-club.template.html?vue&type=template&id=1eb29496&scoped=true"
import script from "./ModifyClub.vue?vue&type=script&lang=ts"
export * from "./ModifyClub.vue?vue&type=script&lang=ts"

import "./ModifyClub.vue?vue&type=style&index=0&id=1eb29496&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1eb29496"

export default script